import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    '[FirstHold] Missing Supabase env vars. VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Disable cross-tab session broadcasting. Supabase v2 uses BroadcastChannel
    // to sync sign-in/sign-out events across tabs on the same origin. In some
    // browser versions this channel is NOT partitioned between normal and incognito
    // windows, allowing a session from a logged-in normal tab to be injected into
    // an incognito tab, bypassing the login page entirely.
    detectSessionInUrl: true,
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'sb-firsthold-auth',   // scoped key — avoids conflicts with other Supabase projects on same domain
  },
});
